
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"8","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.445 11.36V4.03c0-1.13-.104-1.86-.312-2.187-.209-.334-.542-.5-1-.5-.339 0-.711.182-1.117.547-.407.364-.61.778-.61 1.242V8H2.062V2.273c0-.697-.187-1.046-.562-1.046-.23 0-.474.109-.734.328l-.305-.47C1.049.634 1.596.407 2.1.407c.771 0 1.193.446 1.266 1.336l.04.024C4.275.859 5.066.406 5.78.406c.589 0 1.07.18 1.446.54.375.353.562 1.098.562 2.234v8.18H6.445z","fill":"currentColor"}})])
          )
        }
      }
    